import styled from "styled-components";

import { theme } from "@/components/bild/theme";
import { colors } from "@/styles/Variants";

const color = colors.bild;
const { fontFamily, breakpoint } = theme;

export const Headline = styled.div`
  display: flex;
  margin-bottom: 18px;
  font-family: ${fontFamily.gothamXNarrow};
  font-size: 18px;
  font-weight: 700;
  color: ${color.vader500};
  line-height: 1.3;

  & > span > a {
    color: ${colors.bild.vader500};
    text-decoration: underline;
  }

  @media ${breakpoint.medium} {
    font-size: 16px;
  }
  @media ${breakpoint.small} {
    font-size: 16px;
  }
`;

export const Subheader = styled.div`
  display: flex;
  font-weight: 800;
  font-family: ${fontFamily.gotham};
  font-size: 20px;
  color: ${color.vader500};
  margin-bottom: 12px;

  @media ${breakpoint.medium} {
    font-size: 18px;
  }
  @media ${breakpoint.small} {
    font-size: 16px;
  }
`;

export const RadioGroupWrapper = styled.div`
  display: flex;
  margin: 16px 0px;

  & > * {
    margin-right: 24px;
  }
`;

export const TextFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > * {
    margin-bottom: 24px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;

  button:first-child {
    margin-left: 8px;
  }

  @media ${breakpoint.medium} {
    flex-direction: column;

    button:first-child {
      margin-bottom: 8px;
    }
  }
  @media ${breakpoint.small} {
    flex-direction: column;

    button:first-child {
      margin-bottom: 8px;
    }
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  margin-bottom: 12px;
`;
